import { CheckCircle2, ChevronRight } from "lucide-react";
import { Milestone } from "../../types/goals";
import { formatDate } from "../../lib/utils";

interface MilestoneItemProps {
    milestone: Milestone;
    isCurrent: boolean;
    progress: number;
    onClick: () => void;
}
const MilestoneItem = ({ milestone, isCurrent, progress, onClick }: MilestoneItemProps) => (
    <div
        onClick={onClick}
        className="flex items-start space-x-3 p-4 rounded-lg bg-gray-50 dark:bg-gray-700/50 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700"
    >
        <div className="flex-1">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                    <CheckCircle2
                        className={milestone.isCompleted ?
                            'text-green-500 w-5 h-5' :
                            'text-gray-400 w-5 h-5'
                        }
                    />
                    <h4 className="font-medium text-gray-900 dark:text-white">
                        {milestone.title}
                        {!milestone.isCompleted && isCurrent && (
                            <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                                Actual
                            </span>
                        )}
                    </h4>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400" />
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                {milestone.description}
            </p>
            <div className="mt-3 space-y-2">
                <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400">
                    <span>Progreso: {progress}%</span>
                    <span>
                        {formatDate(milestone.startDate)} - {formatDate(milestone.dueDate)}
                    </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                    <div
                        className="bg-blue-600 dark:bg-blue-500 h-2 rounded-full transition-all duration-300"
                        style={{ width: `${progress}%` }}
                    />
                </div>
            </div>
        </div>
    </div>
);

export default MilestoneItem;
